import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/courses";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function update(id, { field, value }) {
  return axios.patch(`${BASE}/${id}`, { field, value });
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}
